export default "__VITE_ASSET__07757229__"